module.exports = __webpack_public_path__ + "static/media/slide.111b5257.png";